<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24">
        <Breadcrumbs :arr="['碳汇管理平台', '政策信息']" />
      </el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item label="主题">
            <el-input size="small" v-model="search.policyTheme" maxlength="100" clearable placeholder="请输入"
              class="inline-input"></el-input>
          </el-form-item>
          <!-- <el-form-item label="组织名称">
                        <el-cascader
                        ref="chooseOs"
                        :options="options"
                        @change='searchOrgChange'
                        :props="{ checkStrictly: true }"
                        :show-all-levels="false"
                        ></el-cascader>
                    </el-form-item> -->
          <el-form-item label="发布类型">
            <el-select v-model="search.type" clearable placeholder="请选择" size="small">
              <el-option label="首页" :value="8"> </el-option>
              <el-option label="碳汇+N" :value="11"> </el-option>
              <el-option label="教育普及" :value="7"> </el-option>
              <el-option label="政策信息发布" :value="0"> </el-option>
              <el-option label="日常动态" :value="1"> </el-option>
              <el-option label="研究成果" :value="3"> </el-option>
              <el-option label="认购公示" :value="10"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item id="time" label="日期">
            <!-- <el-date-picker
                        v-model="search.time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        align="right"
                        style="width:280px;"
                        unlink-panels
                        size="small"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker> -->
            <el-date-picker v-model="search.startYear" type="year" size="small" format="yyyy"
              :picker-options="pickerOptionsYear" value-format="yyyy" style="width: 200px" placeholder="开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="search.endYear" type="year" size="small" format="yyyy" value-format="yyyy"
              :picker-options="pickerOptionsYear1" style="width: 200px" placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round>查询</el-button>
            <el-button size="small" style="margin: 0 0 0 50px" @click="reset" round type="info">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn">
          <!-- class="theme-btn" -->
          <el-button size="small" type="primary" @click="isAddData" round>政策信息</el-button>
        </div>
        <Tables class="table" :columns="columns" :loading="loading" :tableData="tableData">
          <template #type="scope">
            <div>{{ changeType(scope.row.type) }}</div>
          </template>
          <template #accessory="scope">
            <div class="operation" v-for="(item, index) in scope.row.accessory" :key="item.id">
              <a class="color pointer" :href="item.url" target="_blank">
                附件{{ index + 1 }}</a>
            </div>
          </template>
          <template #actions="scope">
            <div class="flex">
              <!-- <span class="theme-color">修改</span>
                            <span class="theme-color">删除</span>
                            <span class="theme-color">详情</span> -->
              <el-button type="text" @click="isEdit(scope.row.id)">修改</el-button>
              <el-button type="text" @click="isDelete(scope.row.id)">删除</el-button>
              <el-button type="text" @click="isView(scope.row.id)">详情</el-button>
            </div>
          </template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
    <modaDialogl :dialog="dialog" :formData="formData" :handleClose="handleClose" :isView="isShowView" />
  </div>
</template>
<script>
import {
  getPolicyInfoList,
  getPolicyDetail,
  delPolicyInfo,
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import modaDialogl from "./components/modaDialogl.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "policyInformation",
  data() {
    return {
      search: {
        endYear: "",
        policyTheme: "",
        startYear: "",
        type: "",
      },
      pickerOptionsYear: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.startYear);
          const end = Date.parse(this.search.endYear);
          if (this.search.endYear) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsYear1: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.startYear);
          const end = Date.parse(this.search.endYear);
          if (this.search.startYear) {
            return (
              time.getTime() < start - 8.64e7
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
      // 表格展示数据
      tableData: [],
      // 表格显示标题
      columns: [],
      loading: false,
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 是否显示操作按钮
      isShowView: true,
      // 用户信息
      userInfo: {},
      // 表单信息
      formData: {},
    };
  },
  methods: {
    // 页面初始化
    init() {
      this.columns = columns;
      this.getList();
      let id = window.localStorage.getItem('policyInformation_detail_id')
      if (id) {
        this.isView(id)
        localStorage.removeItem('policyInformation_detail_id')
      }
    },
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      console.log(this.search)
      getPolicyInfoList(this.search, page).then((res) => {
        if (res.data.code == "200") {
          console.log(res.data.data)
          this.tableData = res.data.data.records;

          // 解决文本带p标签问题,去掉所有的html标签
          // 使用正则去掉里面所有的html标签
          // const reg = /<\/?.+?\/?>/g
          // this.tableData.forEach(item => {
          //   item.policyContent = item.policyContent.replace(reg, '')
          // });

          this.pageData.total = res.data.data.total;
          this.tableData.forEach((item) => {
            item.accessory = item.accessory ? JSON.parse(item.accessory) : [];
          });
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search = {
        endYear: "",
        policyTheme: "",
        startYear: "",
        type: "",
      };
      this.getList();
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false;
    },
    // 新增
    isAddData() {
      this.formData = {
        policyTheme: "", // 政策主题
        startDate: "",
        endDate: "",
        policyContent: "", // 政策内容
        type: "", // 政策类型（0：政策信息发布，1：工作推进成果）
        accessory: "", // 附件
      };
      this.dialog.visible = true;
      this.isShowView = true;
      this.dialog.title = "新增";
    },
    // 修改
    async isEdit(id) {
      const res = await getPolicyDetail(id);
      if (res.data.code == 200) {
        this.formData = res.data.data;
        this.dialog.visible = true;
        this.dialog.title = "修改";
        this.isShowView = true;
      }
    },
    // 详情
    async isView(id) {
      const res = await getPolicyDetail(id);
      if (res.data.code == 200) {
        this.formData = res.data.data;
        this.dialog.visible = true;
        this.dialog.title = "详情";
        this.isShowView = false;
      }
    },
    // 删除
    isDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPolicyInfo(id).then((res) => {
            if (res.data.code == 200) {
              if (this.tableData.length == 1) {
                let page = this.pageData.page - 1;
                page = page <= 0 ? 0 : page;
                this.pageData.page = page;
              }
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 通过类型返回文字
    changeType(type) {
      if (type == 0) return '政策信息发布'
      else if (type == 1) return '日常动态'
      else if (type == 2) return '碳中和'
      else if (type == 3) return '研究成果'
      else if (type == 4) return '零碳园区'
      else if (type == 5) return '零碳景区'
      else if (type == 6) return '零碳农产品'
      else if (type == 7) return '教育普及'
      else if (type == 8) return '首页'
      else if (type == 9) return '宁碳惠项目'
      else if (type == 10) return '认购公示'
      else if (type == 11) return '碳汇+N'
      else return ''
    },
    // 切换条数
    sizeChange(val) {
      this.pageData.size = val
      this.getList()
    },
    // 切换页数
    currentChange(val) {
      this.pageData.page = val
      this.getList()
    },
    setUrl(arr) {
      arr = JSON.parse(arr)
      if (arr.length)
        return arr[0].url
      else return ''
    },
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    modaDialogl,
    Paginations,
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.operation {
  color: #409EFF;
}
</style>
